import Card from '@/shared/components/flip-ui-kit/Card';
import useAllBoostPoolsInfo from '@/shared/hooks/useAllBoostPoolsInfo';
import ChartIcon from '@/shared/icons/flip-ui-kit/large/Chart';
import DropletIcon from '@/shared/icons/flip-ui-kit/large/Droplet';
import MoneyBagIcon from '@/shared/icons/flip-ui-kit/large/MoneyBag';
import { formatUsdValue } from '@/shared/utils/numbers';

export const AllBoostPoolCards = ({ className }: { className?: string }) => {
  const { totalBoostFeeUsd, totalBoostLiquidityUsd, totalBoostVolumeUsd } = useAllBoostPoolsInfo();

  const skeletonLineWidth = 100;

  return (
    <>
      <Card
        skeletonLineWidth={skeletonLineWidth}
        loading={totalBoostLiquidityUsd === null}
        icon={<DropletIcon className="text-cf-light-2" />}
        title="Total Boost Liquidity"
        footer="Current"
        tooltip="The combined USD value of all boost positions"
        className={className}
      >
        <div className="flex flex-wrap items-center gap-x-1.5">
          <span className="text-20 text-white">{formatUsdValue(totalBoostLiquidityUsd)}</span>
        </div>
      </Card>
      <Card
        skeletonLineWidth={skeletonLineWidth}
        loading={totalBoostVolumeUsd === null}
        icon={<ChartIcon className="text-cf-light-2" />}
        title="Filled Volume"
        tooltip="The cumulative USD value of all boosted deposits"
        footer="All time"
        className={className}
      >
        <div className="flex flex-wrap items-center gap-x-1.5">
          <span className="text-20 text-white">{formatUsdValue(totalBoostVolumeUsd)}</span>
        </div>
      </Card>
      <Card
        skeletonLineWidth={skeletonLineWidth}
        loading={totalBoostFeeUsd === null}
        icon={<MoneyBagIcon className="w-[22px] text-cf-light-2" />}
        title="Earned Fees"
        tooltip="The cumulative USD value of all earned fees"
        footer="All time"
        className={className}
      >
        <div className="flex flex-wrap items-center gap-x-1.5">
          <span className="text-20 text-white">{formatUsdValue(totalBoostFeeUsd)}</span>
        </div>
      </Card>
    </>
  );
};
